module.exports = __webpack_public_path__ + "img/mylockersolution-logo.ad166a71.png";